export const TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN'
export const CLOSE_DROPDOWN = 'CLOSE_DROPDOWN'
